import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=620519e8&scoped=true&"
import script from "./index2.vue?vue&type=script&lang=js&"
export * from "./index2.vue?vue&type=script&lang=js&"
import style0 from "../../../../src/css/setting/global.css?vue&type=style&index=0&id=620519e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620519e8",
  null
  
)

export default component.exports